// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pill[data-v-20d88be6] {\n  padding: 2px;\n}\n.pill.isFirst[data-v-20d88be6] {\n  border-top-left-radius: 5px;\n  border-bottom-left-radius: 5px;\n}\n.pill.isLast[data-v-20d88be6] {\n  border-top-right-radius: 5px;\n  border-bottom-right-radius: 5px;\n}\n.pill.has-border[data-v-20d88be6] {\n  border: 1px solid rgb(153, 153, 153);\n  border-left: 0px;\n}\n.w-100[data-v-20d88be6] {\n  width: 100%;\n}\n\n/* Your component styles go here */", ""]);
// Exports
module.exports = exports;
